import { createContext } from 'react';
import { ThemeSlice } from '@/store/slices/theme/types';

export type ThemeContextValue = {
  theme: ThemeSlice['theme'] | string;
  themes: ThemeSlice['themes'];
  addTheme: (name: string) => void;
  changeTheme: (name: string) => void;
  resetTheme: () => void;
};

export const ThemeContext = createContext<ThemeContextValue | null>(null);
